module.exports = __webpack_public_path__ + "img/pr-1.4e3d0b3b.png";